<div class="flex flex-col w-full h-full">
    <div class="flex flex-col flex-auto items-center sm:items-start p-4">
        <div class="text-2xl leading-6 font-medium ng-star-inserted">
            Ubicación sin Tarifa
        </div>

        <div class="text-xl pt-2">
            La dirección ingresada aún no se encuentra registrada dentro de
            nuestras tarifas. Para agregarla, favor de comunicarse con el área
            de atención a clientes.
        </div>

        <div class="flex w-full items-end content-end justify-end">
            <button
                mat-flat-button
                matTooltip="Cerrar"
                (click)="cerrar()"
                class="text-white font-semibold text-sm"
            >
                <mat-icon>close</mat-icon>
                Cerrar
            </button>
            <button
                mat-flat-button
                matTooltip="Enviar Mensaje"
                (click)="abrirConversacion()"
                class="text-white font-semibold text-sm ml-4"
            >
                Enviar mensaje
                <img
                    src="assets/images/imagenesinicio/whats.png"
                    class="w-6 pl-2"
                    alt="Imagen de whatsapp"
                />
            </button>
        </div>
    </div>
</div>
